;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { filesize } from 'filesize';
import * as yup from 'yup';

const FILE_SIZE = 10000000; // bytes

export const SUPPORTED_FORMATS = [
  'application/rtf',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const validationSchema = yup.object({
  resume: yup
    .mixed()
    .test('fileSize', `Filesize exceeds ${filesize(FILE_SIZE)}`, (value: any) => (value ? value?.size <= FILE_SIZE : true))
    .test('fileType', 'file-extension-not-allowed-for-upload', (value: any) =>
      value ? SUPPORTED_FORMATS.includes(value?.type) : true
    )
    .required('input-required'),
});

export type ResumeSettingsInputs = { resume: File | null };

export const initialValues: ResumeSettingsInputs = { resume: null };
